import { render, staticRenderFns } from "./artists-picker.vue?vue&type=template&id=60f2df0e&scoped=true&"
import script from "./artists-picker.vue?vue&type=script&lang=js&"
export * from "./artists-picker.vue?vue&type=script&lang=js&"
import style0 from "./artists-picker.vue?vue&type=style&index=0&id=60f2df0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f2df0e",
  null
  
)

export default component.exports